import React from 'react';

export function useDrawer<T extends any>() {
  const [visible, setVisible] = React.useState(false);
  const [extraData, setExtraData] = React.useState<T>();

  const open = React.useCallback((extraData?: T) => {
    if (extraData) {
      setExtraData(extraData);
    }

    setVisible(true);
  }, []);

  const close = React.useCallback(() => {
    setExtraData(undefined);
    setVisible(false);
  }, []);

  return { drawerProps: { visible }, open, close, data: extraData };
}
